export enum BenchmarkLayoutVariantEnum {
    DEFAULT = "default",
    ERROR = "error",
}

export enum GradientVariantEnum {
    ERROR = "error",
    LOADING = "loading",
}
